import React, { useEffect } from 'react';
import { appGetLocale, appSaveLocale } from '../helpers/appHelper';
import { useLocation, useNavigate } from 'react-router-dom';
import { languageObj } from '../config/config';
import { getProductCategories } from '../apis';
import { useDispatch } from 'react-redux';
import { simplesleep } from '../helpers/simpleHelper';

const Language = () => {
    const dispatch = useDispatch();
    const currentLocale = appGetLocale();
    const changeTo = currentLocale === languageObj.en.locale ? languageObj.hk : languageObj.en;
    const nav = useNavigate();
    const location = useLocation();

    useEffect(() => {
        changeLanguage();
    }, []);

    const changeLanguage = async () => {
        const product_result = await getProductCategories();
        const targetPath = location.state?.prevPath;

        if (!product_result.fail) {
            dispatch({ type: 'SET_PRODUCT_CATEGORIES', payload: product_result });
            appSaveLocale(changeTo);
            await simplesleep(10);

            if (targetPath.includes('/about_us')) {
                nav(targetPath, {state: { neededToRefresh: 'Y' }});
            } else {
                nav(targetPath);
            }
        }
    };

    return (
        <></>
    )
};

export default Language;